import React from 'react'
import PropTypes from 'prop-types'

const DevelopmentErrorDetails = ({ error }) => (
  <div>
    <div>
      <b>Error name: </b> {error.name}
    </div>
    <div>
      <b>Error message: </b> {error.message}
    </div>
    <div>
      <b>Error stack: </b>
      <br /> <pre>{error.stack}</pre>
    </div>
  </div>
)

DevelopmentErrorDetails.defaultProps = {
  error: {}
}

DevelopmentErrorDetails.propTypes = {
  error: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.shape({
      name: PropTypes.string,
      message: PropTypes.string,
      stack: PropTypes.string
    })
  ])
}

export default DevelopmentErrorDetails
